import React, { useEffect, useRef } from "react";
import ConversationTime from "./ConversationTime";
import { textCase } from "../../../../service/ui/UI";
import {
  ConversationsMessage,
  ConversationsType,
} from "../../../../libraries/types_interface/chats/ChatsTypes";
import { TeamMessage } from "../../../../model/chats/TeamConversationMessageModel";
import BubbleText from "../chat_bubbles/BubbleText";
import BubbleImage from "../chat_bubbles/BubbleImage";
import BubbleAudio from "../chat_bubbles/BubbleAudio";
import BubbleVideo from "../chat_bubbles/BubbleVideo";
import BubbleLocation from "../chat_bubbles/BubbleLocation";
import BubbleLink from "../chat_bubbles/BubbleLink";
import { chatsARFMessageTypes } from "../../../../const/ChatsConstant";
import BubbleARF from "../chat_bubbles/BubbleARF";
import BubbleInlineInfo from "../chat_bubbles/BubbleInlineInfo";
import { getDateUptoDate } from "../../../../service/date_service/date_service";
import BubbleDocument from "../chat_bubbles/BubbleDocument";
import ConversationForwaredLabel from "./ConversationForwaredLabel";
import { ReplyMessageDetailModel } from "../../../../model/chats/ReplyMessageDetailModel";
import { ConversationReply } from "./ConversationReply";
import { useSelector } from "react-redux";
import { RootState } from "../../../../libraries/state_reducers/store";
import UtilityHelper from "../../../../service/utilities/UtilityHelper";
import { Message } from "../../../../model/chats/GroupConversationMessageModel";
import { LogoRound } from "../../../../widget/common/ui/Logo";

export const ConversationMessagesList: React.FC<ConversationsType> = ({
  flag,
  userId,
  messages,
  participantDetail,
  handlePressStart,
  handlePressEnd,
  handleClickMessage,
  selectedMesasgeIds,
  longPressStatus = false,
}) => {
  const chatsRefreshTimeStamp = useSelector(
    (state: RootState) => state.chats.timeStamp
  );

  const msgTypeInline: string = "0";

  const bottomRef = useRef<HTMLDivElement | null>(null);
  const countRef = useRef<number>(0);

  const ownStatus = (msg: TeamMessage | Message): boolean => {
    let status = false;
    if (["1", "4"].includes(flag)) {
      // AUTO REPLY
      if (msg?.message_type! === "13") {
        if (userId !== msg?.account_id!) {
          status = true;
        }
      } else {
        if (userId === msg?.account_id!) {
          status = true;
        }
      }
    } else if (flag === "3") {
      if (userId === msg?.account_id) {
        status = true;
      }
    }

    return status;
  };

  const onwerClassName = (msg: TeamMessage | Message): string => {
    let className: string = "";
    if (msg?.message_type === msgTypeInline) {
      className = "group-item-inline";
    } else {
      className = ownStatus(msg)
        ? "group-item-sender justify-content-end"
        : "group-item-receiver";
    }

    return className;
  };

  const scrollToBottom = () => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth", block: "nearest" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  useEffect(() => {
    /* setTimeout(() => {
      scrollToBottom();
    }, 2000); */

    // Create interval
    const intervalId = setInterval(() => {
      if (countRef.current < 2) {
        scrollToBottom();
        console.log(`scroll to bottom`);
      }
      countRef.current++;
    }, 500);

    // Cleanup function: clears interval when component unmounts
    return () => {
      clearInterval(intervalId);
      console.log(`clear scroll bottom interval`);
    };
  }, []);

  useEffect(() => {
    scrollToBottom();
    console.log(`chatsRefreshTimeStamp`);
  }, [chatsRefreshTimeStamp]);

  return (
    <>
      <div className="sticky-grouped-list py-3 position-relative">
        {Object.entries(messages!).map(([date, group]) => (
          <div key={date} className="group">
            <div className="group-header">
              <div className="group-title  bgcolor-grey2 font-size-10_12 font-gotham-book color-black">
                {textCase(getDateUptoDate(new Date(date)))}
              </div>
            </div>
            <ul className="group-items font-size-15_16 font-gotham-book color-black">
              {group.map((msg, key) => (
                <li
                  key={key}
                  className={`${
                    selectedMesasgeIds.includes(msg?.message_id!)
                      ? "selected"
                      : ""
                  } px-3`}
                  onClick={() => handleClickMessage(msg)}
                  onMouseDown={() => handlePressStart(msg)}
                  onMouseUp={() => handlePressEnd()}
                  onMouseLeave={() => handlePressEnd()}
                  onTouchStart={() => handlePressStart(msg)}
                  onTouchEnd={() => handlePressEnd()}
                >
                  {flag === "3" &&
                    !ownStatus(msg) &&
                    UtilityHelper.isNotEmpty(msg?.logo!) &&
                    !(msg?.same_profile ?? false) && (
                      <div
                        className={`profile-detail font-size-11_12 font-gotham-bold font-color-black d-flex align-items-center ${
                          ownStatus(msg) ? "flex-row-reverse" : ""
                        } `}
                      >
                        <LogoRound
                          url={msg?.logo!}
                          isProfile={true}
                          name={msg?.name!}
                          size={20}
                        />
                        <div className="ellipsis line-1 px-2">
                          {ownStatus(msg)
                            ? "you"
                            : UtilityHelper.isNotEmpty(msg?.name!)
                            ? textCase(msg?.name!)
                            : ""}
                        </div>
                      </div>
                    )}

                  <div
                    className={`group-item   ${onwerClassName(msg)} ${
                      flag === "3" ? "px-4" : ""
                    }`}
                  >
                    <div
                      className={`group-item-content group-item-content-${msg?.message_type!} ${
                        chatsARFMessageTypes.includes(msg?.message_type!)
                          ? "ARF-form"
                          : ""
                      }`}
                    >
                      <ConversationMessagesBubble
                        messageDetail={msg}
                        userId={userId}
                        participantDetail={participantDetail}
                        flag={flag}
                        isUser={ownStatus(msg)}
                        deleteLabel={
                          msg?.status === "1"
                            ? (msg.deleted! ?? []).includes(userId)
                              ? "you"
                              : ""
                            : "all"
                        }
                        longPressStatus={longPressStatus}
                      />
                      {msg?.message_type! !== msgTypeInline && (
                        <ConversationTime
                          isUser={ownStatus(msg)}
                          flag={flag}
                          readStatus={msg?.read_status!}
                          deliveredStatus={msg?.delivered_status!}
                          createDate={msg?.create_date!}
                        />
                      )}
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        ))}
        {/* Dummy div to scroll into view */}
        <div ref={bottomRef} />
      </div>
    </>
  );
};

const ConversationMessagesBubble: React.FC<ConversationsMessage> = ({
  messageDetail,
  userId,
  participantDetail,
  flag,
  deleteLabel,
  longPressStatus = false,
}) => {
  const messageType: string = messageDetail?.message_type!;
  const isForwarded: boolean = messageDetail?.forward_status === "1";
  const hasReply: boolean = messageDetail?.replay_status === "1";

  const replyDetail: ReplyMessageDetailModel | null = hasReply
    ? {
        message_id: messageDetail?.message_id!,
        message_type: messageDetail?.replay_message?.message_type!,
        decripted_mesage: messageDetail?.replay_message?.decripted_mesage!,
        account_id: messageDetail?.account_id!,
        name:
          userId === messageDetail?.account_id!
            ? "you"
            : ["1", "4"].includes(flag) && participantDetail != null
            ? participantDetail?.name!
            : "",
      }
    : null;

  const message = messageDetail?.decripted_mesage ?? "";

  return (
    <>
      {UtilityHelper.isNotEmpty(deleteLabel) ? (
        <BubbleText
          messageType={messageDetail?.message_type!}
          message={message}
          deleteLabel={deleteLabel}
        />
      ) : (
        <>
          {isForwarded && <ConversationForwaredLabel />}
          {hasReply && <ConversationReply detail={replyDetail} />}
          {messageType === "0" ? (
            <BubbleInlineInfo
              messageType={messageDetail?.message_type!}
              message={message}
            />
          ) : messageType === "2" ? (
            <BubbleImage
              messageType={messageDetail?.message_type!}
              message={message}
              longPressStatus={longPressStatus}
            />
          ) : messageType === "3" ? (
            <BubbleAudio
              messageType={messageDetail?.message_type!}
              message={message}
              longPressStatus={longPressStatus}
            />
          ) : messageType === "4" ? (
            <BubbleVideo
              messageType={messageDetail?.message_type!}
              message={message}
              longPressStatus={longPressStatus}
            />
          ) : messageType === "5" ? (
            <BubbleLocation
              messageType={messageDetail?.message_type!}
              message={message}
              longPressStatus={longPressStatus}
            />
          ) : ["6", "7", "8"].includes(messageDetail?.message_type!) ? (
            <BubbleDocument
              messageType={messageDetail?.message_type!}
              message={message}
              longPressStatus={longPressStatus}
            />
          ) : messageType === "9" ? (
            <BubbleLink
              messageType={messageDetail?.message_type!}
              message={message}
            />
          ) : chatsARFMessageTypes.includes(messageDetail?.message_type!) ? (
            <BubbleARF
              messageType={messageDetail?.message_type!}
              message={message}
              formType={message.split("|")[2]}
              arfData={{
                group_id: message.split("|")[0],
                request_no: message.split("|")[1],
                form_type: message.split("|")[2],
                name: message.split("|")[3],
                date: new Date(message.split("|")[4]),
                time: message.split("|")[5],
                subject: messageType === "20" ? message.split("|")[6] : "",
                no_people: ["40", "41", "42", "43"].includes(messageType)
                  ? messageType.split("|")[6]
                  : "",
                description: ["30", "31", "32", "33"].includes(messageType)
                  ? message.split("|")[6]
                  : message.split("|")[7],
                approval_status:
                  message.split("|")[message.split("|").length - 1],
              }}
            />
          ) : (
            <BubbleText
              messageType={messageDetail?.message_type!}
              message={message}
              autoReplayStatus={messageType === "13"}
            />
          )}
        </>
      )}
    </>
  );
};
